// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsFUJ{background:#e0e8f2;border-radius:4px;display:-ms-flexbox;display:flex;height:8px;position:relative}._2fhyx{background:transparent;border:none;cursor:pointer;font-size:12px;font-size:1.2rem;height:8px;line-height:24px;padding-top:8px}.Sq7Xz{background:#30a8ff;border-radius:4px}", ""]);
// Exports
exports.locals = {
	"track": "NsFUJ",
	"trackSegment": "_2fhyx",
	"trackSegment--active": "Sq7Xz"
};
module.exports = exports;
